"use strict";

$(function () {

  let installPromptEvent;

  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Stash the event so it can be triggered later.
    installPromptEvent = e;
  });

  // Register service worker
  if (!navigator.serviceWorker.controller) {
    //Register the ServiceWorker
    navigator.serviceWorker.register('/service-worker.js', {
      scope: '/'
    }).then(function (reg) {
      console.log('Service worker has been registered for scope:' + reg.scope);
    });
  }
});